package hk.com.vr360_demo2.webapp.component.viewer

import cc.easyandroid.easycompose.component.ComponentContext
import cc.easyandroid.easycompose.core.instancekeeper.getOrCreate
import cc.easyandroid.easycompose.mvi_main.DefaultStoreFactory
import hk.com.vr360_demo2.webapp.core.net.KtorPublicApi
import hk.com.vr360_demo2.webapp.core.ui_state.UIComponent
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.serialization.builtins.serializer
import org.koin.core.component.KoinComponent

interface ViewerComponent {
    val id: String
    val uid: String?
    val token: String?
    val state: StateFlow<ViewerState>
    val errors: Flow<UIComponent>
    fun dispatch(intent: ViewerIntent)
}

class DefaultViewerComponent(
    context: ComponentContext,
    override val id: String,
    override val uid: String? = null,
    override val token: String? = null,
) : ViewerComponent, KoinComponent, ComponentContext by context {
    private val publicApi get() = getKoin().get<KtorPublicApi>()
    private val idWithUidAndToken = "$id:${uid.orEmpty()}:${token.orEmpty()}"
    private val restoredActiveSceneIndex = stateKeeper.consume(
        key = stateKey(idWithUidAndToken),
        strategy = Int.serializer(),
    )

    private val viewModel: ViewerViewModel =
        instanceKeeper.getOrCreate(retainedKey(idWithUidAndToken)) {
            ViewerViewModel(
                id = id,
                uid = uid,
                token = token,
                publicApi = publicApi,
                restoredActiveSceneIndex = restoredActiveSceneIndex,
                storeFactory = DefaultStoreFactory(),
            )
        }

    override val state: StateFlow<ViewerState> = viewModel.observeState
    override val errors: Flow<UIComponent> = viewModel.errors

    init {
        registerStateKeeper()
    }

    private fun registerStateKeeper() {
        val key = stateKey(idWithUidAndToken)
        if (!stateKeeper.isRegistered(key)) {
            stateKeeper.register(
                key = key,
                strategy = Int.serializer(),
            ) {
                viewModel.state.activeSceneIndex
            }
        }
    }

    override fun dispatch(intent: ViewerIntent) {
        viewModel.accept(intent)
    }

    companion object {
        private const val STATE_KEY_PREFIX = "viewer_state_"
        private const val RETAINED_KEY_PREFIX = "viewer_retained_"

        private fun stateKey(id: String): String = "$STATE_KEY_PREFIX$id"
        private fun retainedKey(id: String): String = "$RETAINED_KEY_PREFIX$id"
    }
}